/** Dates a proposal takes from a media plan, and the date fields' guard. */
/** The plan's flight: its own start/end when set, else the span of its beats' draft and delivery dates (as the API's planDates). */
export function planDateRange(pl: { source?: unknown; beats?: Array<{ dateDrafts?: string | null; dateDeliver?: string | null }> }): [string | undefined, string | undefined] {
  const ok = (d: unknown): d is string => typeof d === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(d);
  const flight = ((pl.source || {}) as { flight?: { start?: string; end?: string } }).flight || {};
  const all = [...(pl.beats || []).flatMap((b) => [b.dateDrafts, b.dateDeliver])].filter(ok).sort();
  return [ok(flight.start) ? flight.start : all[0], ok(flight.end) ? flight.end : all[all.length - 1]];
}

/** Bounds for the Start/End inputs: with a max, Chrome stops the year at four digits ("20261021" gave "202610-02-01"). */
export const DATE_MIN = '2020-01-01';
export const DATE_MAX = '2099-12-31';
/** A date field's value, or undefined when it is empty or not a real date in range. */
export function cleanDate(v: string): string | undefined {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(v) || v < DATE_MIN || v > DATE_MAX) return undefined;
  const d = new Date(`${v}T00:00:00Z`);
  return !Number.isNaN(d.getTime()) && d.toISOString().slice(0, 10) === v ? v : undefined;
}
